import React from 'react';
import { Typography, styled } from '@mui/material';

const DynamicGradientText = styled(Typography)(({ theme }) => ({
  background: `linear-gradient(
    90deg,
    ${theme.palette.primary.main} 0%,
    ${theme.palette.secondary.main} 50%,
    ${theme.palette.success.main} 100%
  )`,
  backgroundSize: '200% auto',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  animation: '$gradient 3s linear infinite',
  display: 'inline-block',

  '@keyframes gradient': {
    '0%': { backgroundPosition: '0% center' },
    '100%': { backgroundPosition: '200% center' }
  }
}));

export default DynamicGradientText;